import { WidgetType } from "@codemirror/view";

export class FrameWidget extends WidgetType {
    constructor(frame) {
        super();
        this.frame = frame;
    }

    toDOM() {
        const element = document.createElement("div");
        element.classList.add("ol-cm-frame-widget", "ol-cm-divider");

        const title = document.createElement("div");
        title.classList.add("ol-cm-frame-title", "ol-cm-heading");
        title.textContent = this.frame.title?.content || "";
        element.appendChild(title);

        if (this.frame.subtitle?.content) {
            const subtitle = document.createElement("div");
            subtitle.classList.add("ol-cm-frame-subtitle", "ol-cm-heading");
            subtitle.textContent = this.frame.subtitle.content;
            element.appendChild(subtitle);
        }

        return element;
    }

    eq(other) {
        return (
            other.frame.title?.content === this.frame.title?.content &&
            other.frame.subtitle?.content === this.frame.subtitle?.content
        );
    }

    ignoreEvent(event) {
        return event.type !== "mouseup";
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}
